var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-timepicker',{attrs:{"hide-header":"","no-close-button":"","state":_vm.state,"placeholder":_vm.placeholder},model:{value:(_vm.internalVal),callback:function ($$v) {_vm.internalVal=$$v},expression:"internalVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }